import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  wasRightRailOpened: false,
  eventTypeBookingIsOpen: false,
  currentContactId: null
}

const slice = createSlice(({
  name: 'crm',
  initialState,
  reducers: {
    setEventTypeBookingIsOpen: (state, payload) => ({ ...state, eventTypeBookingIsOpen: payload.payload }),
    setRightRailOpen: (state, payload) => ({
      ...state,
      wasRightRailOpened: payload.payload
    }),
    setCurrentContactId: (state, payload) => ({
      ...state,
      currentContactId: payload.payload
    })
  }
}
))

export const {
  reducer,
  actions: {
    setRightRailOpen,
    setEventTypeBookingIsOpen,
    setCurrentContactId
  }
} = slice
